import React, { useEffect, useMemo, useState } from "react";
import styles from "./PackagerPendingOrder.module.scss";
import { Button, Menu, MenuItem, Checkbox, ListItemText } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  getAllCustomer,
  getAllOrders,
  getAllStates,
  getCustomerById,
  getPackedOrders,
  getPendingOrders,
  getPendingOrdersResponse,
  getProductById,
} from "../../store/actions";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import { getObjectFromArrayOfObjects } from "../../utils/common/CommonFunctions";

const columns = [
  { id: 1, label: "S.NO", minWidth: 120, align: "center" },
  { id: 2, label: "Order ID", minWidth: 170, align: "center" },
  { id: 3, label: "Cart Bundle ID", minWidth: 170, align: "center" },
  { id: 4, label: "Customer Name", minWidth: 170, align: "center" },
  { id: 5, label: "Status", minWidth: 170, align: "center" },
];

const statusOptions = [
  { value: 0, label: "Placed" },
  { value: 1, label: "Packed" },
  { value: 2, label: "Shipped" },
  { value: -1, label: "Cancelled" },
];

const PackagerPendingOrder = ({
  order = {},
  customers = [],
  pendingOrders = [],
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    dispatch(getPendingOrders());
    dispatch(getAllStates());
  }, [order]);

  useEffect(() => {
    dispatch(getAllCustomer());
  }, []);

  const filteredOrders = useMemo(() => {
    const allowedStatuses = statusOptions.map((option) => option.value);
    const baseOrders = Array.isArray(pendingOrders)
      ? pendingOrders.filter((item) => allowedStatuses.includes(item?.status))
      : [];

    const statusFiltered = selectedStatuses.length
      ? baseOrders.filter((item) => selectedStatuses.includes(item?.status))
      : baseOrders;

    if (!searchQuery.trim()) {
      return statusFiltered;
    }

    const loweredQuery = searchQuery.trim().toLowerCase();

    return statusFiltered.filter((item) => {
      const customerName =
        getObjectFromArrayOfObjects(customers, "id", item?.customerId)
          ?.fullName || "";

      return customerName.toLowerCase().includes(loweredQuery);
    });
  }, [pendingOrders, selectedStatuses, searchQuery, customers]);

  const handleBtn = (status) => {
    const btnProps = {
      variant: "contained",
      disableRipple: true,
      disableElevation: true,
    };

    switch (status) {
      case -1:
        return (
          <Button {...btnProps} className={styles.ovalButton4}>
            Cancelled
          </Button>
        );
      case 0:
        return (
          <Button {...btnProps} className={styles.ovalButton0}>
            Placed
          </Button>
        );
      case 1:
        return (
          <Button {...btnProps} className={styles.ovalButton1}>
            Packed
          </Button>
        );
      case 2:
        return (
          <Button {...btnProps} className={styles.ovalButton2}>
            Shipped
          </Button>
        );
      default:
        return null;
    }
  };

  // const handleNavigate = (item = {}) => {
  //   dispatch(getPendingOrdersResponse(item));
  //   dispatch(getProductById({ id: item?.productId }));
  //   dispatch(getCustomerById({ id: item?.customerId }));
  //   setTimeout(() => {
  //     navigate("/orderdetails");
  //   }, 100);
  // };

  const handleNavigate = (item = {}) => {
    console.log(item, "item");
    dispatch(getPendingOrdersResponse(item));
    dispatch(getProductById({ id: item?.productId }));
    dispatch(getCustomerById({ id: item?.customerId }));

    navigate("/orderdetails");
  };

  const getStructuredRows = (data) => {
    return data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          disableElevation
          onClick={() => handleNavigate(item)}
        >
          {item?.orderCode || "NA"}
        </Button>,
        item?.cartBundleId,
        getObjectFromArrayOfObjects(customers, "id", item?.customerId)
          ?.fullName || "NA",
        handleBtn(item?.status),
      ],
    }));
  };

  const handleFilterClick = (event) => setAnchorEl(event.currentTarget);
  const handleFilterClose = () => setAnchorEl(null);

  const handleToggleStatus = (statusValue) => {
    setSelectedStatuses((prev) =>
      prev.includes(statusValue)
        ? prev.filter((s) => s !== statusValue)
        : [...prev, statusValue]
    );
    // handleFilterClose();
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            <SearchInput
              placeholder="Search by customer name"
              onSearch={setSearchQuery}
              minWidth={"300px"}
            />

            {/* <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
              onClick={handleFilterClick}
            >
              Filter
            </Button> */}

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleFilterClose}
            >
              {statusOptions?.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => handleToggleStatus(option.value)}
                >
                  <Checkbox
                    checked={selectedStatuses.includes(option.value)}
                    size="small"
                  />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Menu>
          </div>
        </div>

        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(filteredOrders)}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  order: state?.orders?.order,
  customers: state?.customer?.customers,
  pendingOrders: state?.orders?.orders,
});

export default connect(mapStateToProps, null)(PackagerPendingOrder);
